/* unplugin-vue-components disabled */
import $profile from 'stores/profile'
import ShareDropdown from './share-dropdown.vue'

export default {
  components: {
    ShareDropdown
  },
  props: {
    chat: {type: Object, required: true},
  },
  emits: ['show'],
  data() {
    return {
      loading: false,
      shared: !!this.chat.share,
      //TODO
      // suggestions: [],
      // search: '',
      // userIds: new Set(this.share?.user_ids) || new Set(),
      // shareUsers: this.share?.users || [],
      // readonly: !!this.share?.readonly,
    }
  },
  computed: {
    changed(){
      return this.shared !== !!this.share
    },
    company(){
      return $profile.company_site || $profile.company_name
    },
    share_link() {
      return `${window.location.origin}/share-chat?id=${this.chat.id}`
    },
    size(){
      return 'min(48rem, 90%)'
    }
    //TODO
    // shareIds() { 
    //   return this.shareUsers.map(u => u.id) 
    // },
  },
  watch: {
    shared: async function (val) {
      if (val) await this.shareChat()
      else await this.revokeChat()
      this.shared = !!this.chat.share
    }
  },
  methods: {
    open(){
      this.$refs.modal.open()
    },
    close() {
      this.$refs.modal.close()
    },
    copyLink(message = 'Chat link is copied to clipboard.'){
      $utils.copyText(this.share_link)
      $utils.toasts.success(message)
    },
    async revokeChat() {
      this.loading = true
      try {
        await this.chat.revokeChat()
        $utils.toasts.success(`Sharing has been revoked for chat '${this.chat.title}'.`)
      }
      catch (err) {
        $utils.toasts.error(err)
      }
      this.loading = false
    },  
    async shareChat() {
      this.loading = true
      try {
        const params = {readonly: false}
        //TODO
        // if (this.shareIds) {
        //   params.user_ids = this.shareIds
        // }
        await this.chat.shareChat(params)
        this.copyLink(`Chat '${this.chat.title}' is now accessible via link. Link is copied to clipboard.`)
      }
      catch(err) {
        $utils.toasts.error(err)
      }
      this.loading = false
    },
    //TODO: later
    // async onAutoComplete() {
    //   const rest = new Rest()
    //   this.suggestions = await rest.get(`${API_SHARE_CHAT}/users/search?query=${this.search}`)
    // },
    // onItemSelect(event){
    //   const value = event.value
    //   if (!value) return
    //   if (!this.shareUsers.some(u => u.id === value.id)) {
    //     this.shareUsers = [...this.shareUsers, {...value}]
    //   }
    //   this.search = ''
    // },
    // removeUser(id) {
    //   this.shareUsers = this.shareUsers.filter(u => u.id !== id)
    // },
  }
}
